/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      //this.data = this.getProductData();
      this.productForm = this.section.querySelector('product-form');
      this.dataProduct = this.getProductDataProduct();
      this.dataFormatted = this.getProductDataFormatted();
	  if (this.dataProduct && this.dataProduct.tags.includes('pack')) {
		  this.mainProduct = this.getMainProductData();
	  } else {
		  this.mainProduct = null;
	  }
	
	  this.mainProductAvailabilityMap = new Map();
	  if (this.mainProduct && this.mainProduct.variants) {
		  this.mainProduct.variants.forEach(variant => {
			  const key = variant.options.sort().join('::');
			  this.mainProductAvailabilityMap.set(key, variant);
		  });
	  }

      this.productId = this.dataProduct.id;

      this.quickAddDrawer = this.closest('quick-add-drawer');

      this.sectionsContent = {};

      this.showBIS = this.productForm.hasAttribute('data-show-bis');

      this.updateAvailability();
      this.addEventListener('change', this.handleVariantChange.bind(this));

	  const selectedOptions = this.getSelectedOptions();
	   this.variant = this.dataProduct.variants.find((v) =>
	      v.options.every((val, index) => val === selectedOptions[index])
	  );

      this.isKit = this.section.hasAttribute('data-product-kit');
      if (this.isKit) {
        this.container = this.closest('.kit-container');
        this.productForm = this.container.querySelector('.product-info__product-form product-form');
        this.addToCartBtn = this.productForm.querySelector('[name="add"]');
        this.addToCartBtnTitle = this.productForm.querySelector('[name="add"] .add-to-cart__title');
        this.kitAvailable = this.container.dataset.kitAvailable;
        if (this.kitAvailable == 'false') {
          this.addToCartBtn.setAttribute('disabled', '');
          this.addToCartBtnTitle.textContent = theme.strings.noStock;
        }
      }

      this.isFeaturedProduct = this.section.hasAttribute('data-featured-product');

      this.oneAtc = this.section.hasAttribute('data-one-atc');
      if (this.oneAtc) {
          this.container = this.closest('.products-with-one-atc');
          this.productForm = this.container.querySelector('.product-info__product-form product-form');
      }

      if (this.mainProduct && this.mainProduct.variants) {
          this.variantPrices = this.mainProduct.variants.reduce((map, variant) => {
              map[variant.id] = variant.price;
              return map;
					}, {});
					this.updatePrice();
      }

	  if (!this.isKit && !this.quickAddDrawer) {
        this.notifyEvents();
      }

      this.init();
    }

		connectedCallback() {
			this.initSiblingProductPreloading();
		}

    init() {
      this.optionsMap = {};
      if (this.dataProduct.options.length > 1) this.linkOptionSelectors(this.dataProduct);
      setTimeout(this.changeSizeOrder.bind(this), 200);
	  this.adjustColorLabelPosition();
    }

    notifyEvents() {
      this.notifyBtn = this.productForm.querySelector('#custom_notify_button');
      this.notifyText = this.productForm.querySelector('.custom_notify_button_wrapper');
      this.notifyPopup = document.querySelector('.custom-notify-popup');
	  if (!this.notifyPopup) return;

      this.notifyClose = this.notifyPopup.querySelector('.notify-close');
      this.notifySelect = this.notifyPopup.querySelector('#notify_variants');
      this.notificationType = this.notifyPopup.querySelectorAll('#notification-type div');
      this.notificationTypeInputs = this.notifyPopup.querySelectorAll('.notification-type-input');
      this.notifyForm = this.notifyPopup.querySelector('form');

      const initPhoneInput = () => {
        const phoneInputField = this.notifyPopup.querySelector('#notify-sms');
        if (phoneInputField && window.intlTelInput) {
          this.phoneInput = window.intlTelInput(phoneInputField, {
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
          });
        }
      };

      if (this.notifyBtn) {
        let script = document.getElementById('intl-tel-input-script');

        if (!script) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.css';
          document.head.appendChild(link);

          script = document.createElement('script');
          script.id = 'intl-tel-input-script';
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js';

          script.onload = initPhoneInput;

          document.head.appendChild(script);
        } else if (window.intlTelInput) {
          initPhoneInput();
        } else {
          script.addEventListener('load', initPhoneInput);
        }
      }

      if (this.notifyBtn) {
        this.notifyBtn.addEventListener('click', this.openNotifyPopup.bind(this));
      }

      this.notifyPopup.addEventListener('click', (evt) => {
        var div = this.notifyPopup.querySelector('.notify-modal');
        if (!div.contains(evt.target)) {
          this.closeNotifyPopup();
        }
      });

      if (this.notifyClose) {
        this.notifyClose.addEventListener('click', () => {
          this.closeNotifyPopup();
        });
      }

      this.notificationType.forEach((item) => {
        item.addEventListener('click', () => {
          if (this.notifyForm.querySelector('.text-error-text')) this.notifyForm.querySelector('.text-error-text').remove();
          this.notificationType.forEach((item) => item.classList.remove('active'));
          this.notificationTypeInputs.forEach((input) => {
            input.setAttribute('hidden', '');
            input.querySelector('input').removeAttribute('required');
          });

          let type = item.getAttribute('data-notification-type');
          let currentInput = Array.from(this.notificationTypeInputs).find((input) => input.getAttribute('data-notification-type') === type);

          item.classList.add('active');
          if (currentInput) {
            currentInput.removeAttribute('hidden');
            currentInput.querySelector('input').setAttribute('required', true);
          }
        });
      });

      this.notifyForm.addEventListener('submit', (e) => {
        e.preventDefault();
        let notificationType = this.notifyPopup.querySelector('#notification-type .active').getAttribute('data-notification-type');

        let select = this.notifyPopup.querySelector('#notify_variants');
        let selectedOption = select.options[select.selectedIndex];

        if (!selectedOption) {
          return;
        }

        let productId = selectedOption.getAttribute('data-product-id');
        let acceptsMarketing = this.notifyPopup.querySelector('#customer_accepts_marketing').checked;

        if (this.notifyForm.querySelector('.text-error-text')) this.notifyForm.querySelector('.text-error-text').remove();
        this.toggleButtonVisibility(false);

        if (notificationType == 'email') {
          let email = this.notifyPopup.querySelector('#notify-email').value;
          if (!email) return;

          BIS.create(email, select.value, productId, {
            accepts_marketing: acceptsMarketing
          }).then((resp) => {
            if (resp.status === 'OK') {
              this.closeNotifyPopup();
            } else {
              let errorBlock = document.createElement("p");
              errorBlock.textContent = resp.errors.base[0];
              errorBlock.classList.add('text-error-text');

              this.notifyForm.querySelector('[type="submit"]').after(errorBlock);
              this.toggleButtonVisibility(true);
            }
          });
        } else {
          let sms = phoneInput.getNumber();
          if (!sms) return;

          BIS.create(null, select.value, productId, {
            phone_number: sms,
            accepts_marketing: acceptsMarketing
          }).then((resp) => {
            if (resp.status === 'OK') {
              this.closeNotifyPopup();
            } else {
              let errorBlock = document.createElement("p");
              errorBlock.textContent = resp.errors.phone_number[0];
              errorBlock.classList.add('text-error-text');
              this.notifyForm.querySelector('[type="submit"]').after(errorBlock);
              this.toggleButtonVisibility(true);
            }
          });

        }

      });
    }

    changeSizeOrder = function() {
      let optionSizeWrapper = this.querySelector('.option-selector-size');
      if (!optionSizeWrapper) return;

      let optionSizeParent = optionSizeWrapper.querySelector('.option-selector__btns');
      let optionXS = optionSizeWrapper.querySelector('[data-value="XS"]');

      if (optionXS && optionSizeParent) {
        optionSizeParent.prepend(optionXS);
      }
    }

    linkOptionSelectors = function (product) {
      // Building our mapping object.

      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant) {
          if (product.product_fit_option) {
            this.optionsMap['root'] = this.optionsMap['root'] || [];
            this.optionsMap['root'].push(variant.option0);
            this.optionsMap['root'] = [...new Set(this.optionsMap['root'])];

            // Gathering values for the 1st drop-down.
            var key = variant.option0;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option1);
            this.optionsMap[key] = [...new Set(this.optionsMap[key])];

            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
              var key = variant.option0 + ' / ' + variant.option1;
              this.optionsMap[key] = this.optionsMap[key] || [];
              this.optionsMap[key].push(variant.option2);
              this.optionsMap[key] = [...new Set(this.optionsMap[key])];
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length > 2) {
              var key = variant.option0 + ' / ' + variant.option1 + ' / ' + variant.option2;
              this.optionsMap[key] = this.optionsMap[key] || [];
              this.optionsMap[key].push(variant.option3);
              this.optionsMap[key] = [...new Set(this.optionsMap[key])];
            }
          } else {
            // Gathering values for the 1st drop-down.
            this.optionsMap['root'] = this.optionsMap['root'] || [];
            this.optionsMap['root'].push(variant.option1);
            this.optionsMap['root'] = [...new Set(this.optionsMap['root'])];

            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
              var key = variant.option1;
              this.optionsMap[key] = this.optionsMap[key] || [];
              this.optionsMap[key].push(variant.option2);
              this.optionsMap[key] = [...new Set(this.optionsMap[key])];
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
              var key = variant.option1 + ' / ' + variant.option2;
              this.optionsMap[key] = this.optionsMap[key] || [];
              this.optionsMap[key].push(variant.option3);
              this.optionsMap[key] = [...new Set(this.optionsMap[key])];
            }
          }
        }
      }

      // console.log('this.optionsMap', this.optionsMap);

      // Update options right away.
      this.updateOptionsInSelector(0);
      if (product.options.length > 1) this.updateOptionsInSelector(1);
      if (product.options.length > 2) this.updateOptionsInSelector(2);
      if (product.options.length > 3) this.updateOptionsInSelector(3);
      // When there is an update in the first dropdown.
      this.querySelectorAll('.single-option-selector')[0].addEventListener('change', () => {
        this.updateOptionsInSelector(1);
        if (product.options.length > 2) this.updateOptionsInSelector(2);
        if (product.options.length > 3) this.updateOptionsInSelector(3);
        return true;
      });
      // When there is an update in the second dropdown.
      this.querySelectorAll('.single-option-selector')[1].addEventListener('change', () => {
        if (product.options.length > 2) this.updateOptionsInSelector(2);
        if (product.options.length > 3) this.updateOptionsInSelector(3);
        return true;
      });
      if (this.querySelectorAll('.single-option-selector')[2]) {
        this.querySelectorAll('.single-option-selector')[2].addEventListener('change', () => {
          if (product.options.length > 3) this.updateOptionsInSelector(3);
          return true;
        });
      }
    };

    updateOptionsInSelector = function (selectorIndex) {
      switch (selectorIndex) {
        case 0:
          this.key = 'root';
          this.selector = this.querySelectorAll('.single-option-selector')[0];
          break;
        case 1:
          this.key = this.querySelectorAll('.single-option-selector')[0].value;
          this.selector = this.querySelectorAll('.single-option-selector')[1];
          break;
        case 2:
          this.key = this.querySelectorAll('.single-option-selector')[0].value;
          this.key += ' / ' + this.querySelectorAll('.single-option-selector')[1].value;
          this.selector = this.querySelectorAll('.single-option-selector')[2];
          break;
        case 3:
          this.key = this.querySelectorAll('.single-option-selector')[0].value + ' / ' +
              this.querySelectorAll('.single-option-selector')[1].value + ' / ' +
              this.querySelectorAll('.single-option-selector')[2].value;
          this.selector = this.querySelectorAll('.single-option-selector')[3];
          break;
      }

      var initialValue = this.selector.value;

      while (this.selector.firstChild) {
        this.selector.removeChild(this.selector.firstChild);
      }

      var availableOptions = this.optionsMap[this.key];
      var optionIndex = selectorIndex + 1;

      if(optionIndex > 1) {
        this.querySelectorAll('[data-option="option-' + optionIndex + '"] .option-wrapper').forEach((optionWrapper) => {
					optionWrapper.style.display = 'none';
	        // optionWrapper.classList.remove('first-visible');
        });
      }

      // console.log('availableOptions', availableOptions);

      for (var i = 0; i < availableOptions.length; i++) {
        var option = availableOptions[i];
        var newOption = document.createElement('option');
        newOption.value = option;
        newOption.textContent = option;

        this.selector.appendChild(newOption);

        if (optionIndex > 1) {
          option = option.replace(/"/g, '\\"');
          this.querySelector('[data-option="option-' + optionIndex + '"] .option-wrapper[data-value="' + option + '"]').style.display = 'block';
        }
      }

	    // if (optionIndex > 1) {
		  //   const wrappers = this.querySelectorAll('[data-option="option-' + optionIndex + '"] .option-wrapper');
		  //   for (const wrapper of wrappers) {
			//     if (getComputedStyle(wrapper).display !== 'none') {
			// 	    wrapper.classList.add('first-visible');
			// 	    break;
			//     }
		  //   }
	    // }

      if (availableOptions.includes(initialValue)) {
        this.selector.value = initialValue;
      }

      var newValue = this.selector.value;

      var event = new Event('change');
      this.selector.dispatchEvent(event);

      let newValueBlock = this.querySelector('[data-option="option-' + optionIndex + '"] .option-wrapper[data-value="' + newValue + '"] input');
      newValueBlock.checked = true;
    };

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const selectedOptions = this.getSelectedOptions();
      const productId = evt.target.dataset.productId;
      if (productId) this.productId = productId;
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.dataProduct.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );

	    this.variantPreorder = this.dataFormatted[this.variant.id].preorder ? true : false;

      if (this.variant) {
        this.productId = this.variant.product_id;
        !this.isKit ? this.updateMedia() : this.updateKitMedia(this.variant.featured_media.id);
        if (!this.isKit && !this.variant.ignore_url_change) {
          this.updateUrl(evt);
        }
        this.updateVariantInput();
        this.updateSizingDropdown();

        let sectionProductId = Number(this.dataset.productId);
        if (sectionProductId !== this.variant.product_id) {
          this.setAttribute('data-product-id', this.variant.product_id);
        }
        if (evt.target.getAttribute('data-option-name') === 'Fit') {
          const displayValue = evt.target.hasAttribute('data-has-additional-colors') ? 'block' : 'none';

          this.querySelectorAll('legend[data-additional-color]').forEach((label) => {
            label.style.display = displayValue;
          });

          this.updatePageContent();
          this.updateProductIdOnSwatches(evt.target.dataset.productId);
        }

        this.updateShopPayId();
      }

      this.updateAddToCartButton();
      this.updateNotifyButton();
      this.updateAvailability(evt);
      this.updatePrice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      this.updateShippingDate();
	  this.adjustColorLabelPosition();

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm.querySelector('form'),
          variant: this.variant,
          product: this.dataProduct
        }
      }));
    }

    updateProductIdOnSwatches(productId) {
      const mainSwatches = this.querySelectorAll('.option-selector input[data-main-swatch]');
      mainSwatches.forEach((swatch) => {
        swatch.setAttribute('data-product-id', productId);
      });
    }

    updateShopPayId() {
      this.shopPayVariantId = this.section.querySelector('.shop-pay-variant-id');
      if (!this.shopPayVariantId) return;

      this.shopifyPaymentTerms = this.section.querySelector('shopify-payment-terms');
      if (!this.shopifyPaymentTerms) return;

      this.shopPayVariantId.value = this.variant.id;
      this.shopifyPaymentTerms.setAttribute('variant-id', `${this.variant.id}`);
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton({ isPack = false, hasUnavailable = false } = {}) {
      if (!this.productForm) return;

	  this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
	  this.addBtnTitle = this.productForm.querySelector('[name="add"] .add-to-cart__title');
      this.addBtnPriceWrapper = this.addBtn.querySelector('.price__default');

      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
			
			if (hasUnavailable) {
				this.addBtn.disabled = true;
				this.addBtnTitle.textContent = theme.strings.noStock;
			} else {
				this.addBtn.disabled = false;
				this.addBtnTitle.textContent = theme.strings.addToCartBtn;
			}

      if (isPack) {
          if (this.showBIS) {
              if (hasUnavailable) {
                  this.addBtn.setAttribute('hidden', '');
              } else {
                  this.addBtn.removeAttribute('hidden');
              }
          }

          return;
      }

      if (this.addBtnPriceWrapper) {
        this.addBtnCompareAtPrice = this.addBtnPriceWrapper.querySelector('.price__was');
        this.addBtnPrice = this.addBtnPriceWrapper.querySelector('.price__current');

        if (!variantAvailable && this.addBtnPriceWrapper) {
          this.addBtnPriceWrapper.classList.add('hidden');
        } else if (variantAvailable && this.addBtnPriceWrapper) {
          this.addBtnPriceWrapper.classList.remove('hidden');
        }

        if (variantAvailable) {
          this.addBtnPrice.textContent = this.dataFormatted[this.variant.id].price;
          this.addBtnCompareAtPrice.textContent = this.dataFormatted[this.variant.id].compareAtPrice || '';
          if (!this.addBtnPrice.classList.contains('has-compare')) {
            this.addBtnPrice.classList.add('has-compare');
          }
        }
      }

			if (this.quickAddDrawer) {
				this.addBtn.disabled = !variantAvailable;

				if (variantAvailable) {
					this.addBtn.removeAttribute('hidden');
				} else {
					this.addBtn.setAttribute('hidden', '');
				}
			} else if (!this.isKit && !this.oneAtc) {
				if (this.showBIS) {
					if (variantAvailable) {
						this.addBtn.removeAttribute('hidden');
					} else {
						this.addBtn.setAttribute('hidden', '');
					}
				} else {
					this.addBtn.disabled = !variantAvailable;
				}
			}

			if (this.oneAtc) {
				const allForms = this.container.querySelectorAll('.js-product');
				let parentContainer = this.closest('.js-product');
				let hasUnavailable = false;
				let hasPreorder = false;

				parentContainer.dataset.available = this.variant.available
				parentContainer.dataset.preorder = this.dataFormatted[this.variant.id].preorder ? this.dataFormatted[this.variant.id].preorder : false
				if (this.dataFormatted[this.variant.id].preorder == true) {
					parentContainer.dataset.available = true;
				}

				Array.from(allForms).forEach(el => {
					if (el.dataset.available === "false") {
						hasUnavailable = true;
					} else if (el.dataset.preorder === "true") {
						hasPreorder = true;
					}
				});

				if (hasUnavailable || hasPreorder) {
					this.addBtn.setAttribute('disabled', '');
					this.addBtnTitle.textContent = unavailableStr;
				} else {
					this.addBtn.removeAttribute('disabled');
					this.addBtnTitle.textContent = window.theme.strings.addToCartBtn;
				}

                if (this.container.classList.contains('has-sticky-atc')) {
                    const stickyAtc = document.querySelector('.sticky-atc');
                    if (stickyAtc) {
                        if (hasUnavailable || hasPreorder) {
                            stickyAtc.setAttribute('disabled', '');
                            stickyAtc.querySelector('.add-to-cart__title').textContent = unavailableStr;
                        } else {
                            stickyAtc.removeAttribute('disabled');
                            stickyAtc.querySelector('.add-to-cart__title').textContent = window.theme.strings.addToCartBtn;
                        }
                    }
                }

			} else if (this.isKit) {
        let parentContainer = this.closest('.product-info');
        let currentBundleItems = this.container.querySelectorAll('.product-info.kit-item--current');

        if (+parentContainer.dataset.price !== this.variant.price * parentContainer.dataset.qty) {
          parentContainer.dataset.price = this.variant.price * parentContainer.dataset.qty;
          this.closest('.product-kit').updateTotalPrice(currentBundleItems);
        }

        if (this.kitAvailable == 'true') {
          const { inventory_quantity } = this.dataFormatted[this.variant.id];
          parentContainer.dataset.available = this.variant.available && inventory_quantity >= +parentContainer.dataset.qty;
	        parentContainer.dataset.preorder = this.dataFormatted[this.variant.id].preorder ? this.dataFormatted[this.variant.id].preorder : false
	        if (this.dataFormatted[this.variant.id].preorder == true) {
		        parentContainer.dataset.available = true;
	        }

	        let hasUnavailable = false;
	        let hasPreorder = false;

	        Array.from(currentBundleItems).forEach(bundle => {
		        if (bundle.dataset.available === "false") {
			        hasUnavailable = true;
		        } else if (bundle.dataset.preorder === "true") {
			        hasPreorder = true;
		        }
	        });

	        if (hasUnavailable || hasPreorder) {
		        this.addBtn.setAttribute('disabled', '');
		        this.addBtnTitle.textContent = unavailableStr;
	        } else {
		        this.addBtn.removeAttribute('disabled');
		        this.addBtnTitle.textContent = window.theme.strings.addToCartBtn;
	        }
        }
      } else {
	      this.addBtn.classList.remove('btn--preorder');
	      if (this.variantPreorder) {
		      this.addBtn.classList.add('btn--preorder');
		      this.addBtnTitle.textContent = window.theme.strings.preOrder;
	      } else {
		      this.addBtnTitle.textContent = variantAvailable
			      ? window.theme.strings.addToCartBtn
			      : unavailableStr;
	      }
      }
    }

    updateNotifyButton({ isPack = false, hasUnavailable = false } = {}) {
      if (!this.productForm) return;

      const variantAvailable = this.variant && this.variant.available;

      if (variantAvailable) {
        if (this.notifyBtn) this.notifyBtn.setAttribute('hidden', '');
      } else {
        if (this.notifyBtn) this.notifyBtn.removeAttribute('hidden');
      }
    }

    openNotifyPopup() {
      this.notifyPopup.removeAttribute('hidden');
      if (this.variant && !this.variant.available) this.notifySelect.value = this.variant.id;
    }

    closeNotifyPopup() {
      this.notifyPopup.setAttribute('hidden', '');
      this.toggleButtonVisibility(true);
      if (this.notifyForm.querySelector('.text-error-text')) this.notifyForm.querySelector('.text-error-text').remove();
    }

    toggleButtonVisibility(showButton) {
      const button = this.notifyForm.querySelector('[type="submit"]');
      if (button) {
        const svg = button.querySelector('svg');
        const span = button.querySelector('span');
        if (showButton) {
          svg.setAttribute('hidden', '');
          span.removeAttribute('hidden');
        } else {
          svg.removeAttribute('hidden');
          span.setAttribute('hidden', '');
        }
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability(e) {
      if (this.dataset.showAvailability === 'false') return;

			const thisProduct = this.getSiblingProductData(e);
			const selectedOptions = this.getSelectedOptions();
			const idInput = this.productForm.querySelector('[name="id"]');
	    
	    const isPackProduct = thisProduct && thisProduct.tags && thisProduct.tags.some(tag => tag.includes('pack'));
	    
	    if (isPackProduct && (!this.mainProduct || !this.mainProductAvailabilityMap.size)) {
		    const mainProdDataEl = this.querySelector(`[type="application/json"][data-main-product-for="${thisProduct.handle}"]`);
		    
		    if (mainProdDataEl && mainProdDataEl.textContent) {
			    try {
				    const mainJson = JSON.parse(mainProdDataEl.textContent);
				    this.mainProduct = mainJson.product;
						
				    this.mainProductAvailabilityMap = new Map();
				    this.variantPrices = {};
				    if (this.mainProduct && this.mainProduct.variants) {
					    this.mainProduct.variants.forEach(variant => {
						    const key = variant.options.sort().join('::');
						    this.mainProductAvailabilityMap.set(key, variant);
						    this.variantPrices[variant.id] = variant.price;
					    });
				    }
			    } catch (err) {
				    console.error('Error:', err);
			    }
		    }
	    }

			// PACK LOGIC
			if (isPackProduct && this.mainProduct) {
				this.showBIS = false;
				const activePackInput = this.querySelector('.option-selector-siblings input.js-option:checked');
				const packQuantity = activePackInput ? parseInt(activePackInput.dataset.packQuantity, 10) || 0 : 0;
				const packDiscountPercent = activePackInput ? parseInt(activePackInput.dataset.packDiscount, 10) || 0 : 0;

				if (idInput && packDiscountPercent) {
					idInput.setAttribute('data-pack-discount', packDiscountPercent);
				} else if (idInput) {
					idInput.removeAttribute('data-pack-discount');
				}

				this.optionSelectors.forEach((selector, selectorIndex) => {
					const isPackSelector = selector.classList.contains('option-selector-siblings');
					
					selector.querySelectorAll('.js-option').forEach(optionEl => {
						let isAvailable;
						if (isPackSelector) {
							/*if (optionEl.checked) {
								isAvailable = this._isPackCombinationAvailable(selectedOptions);
							} else {
								isAvailable = true;
							}*/
                            isAvailable = this._isPackCombinationAvailable(selectedOptions);
						} else {
							const hypotheticalOptions = [...selectedOptions];
							hypotheticalOptions[selectorIndex] = optionEl.value;
							isAvailable = this._isPackCombinationAvailable(hypotheticalOptions);
						}
						this._updateSingleOptionUI(optionEl, isAvailable, !isAvailable);
					});
				});

				const isCurrentSelectionAvailable = this._isPackCombinationAvailable(selectedOptions);

				const packBuildingOptions = selectedOptions.slice(1);
				const packDefinitionString = packBuildingOptions[0];
				const rawColors = packDefinitionString.includes(' / ') ? packDefinitionString.split(' / ').map(s => s.trim()) : [packDefinitionString];
				const otherOptions = packBuildingOptions.slice(1);
				const variantIdsWithQty = [];
				const selectedPackTitle = selectedOptions[0];
				const activeOptionWrapper = selectedPackTitle
					? this.querySelector(`.option-wrapper[data-value="${selectedPackTitle}"]`)
					: null;

				rawColors.forEach(entry => {
					const match = entry.match(/^(\d+)\s+(.*)$/);
					const count = match ? parseInt(match[1], 10) : 1;
					const color = match ? match[2] : entry;
					const variantOptions = [color, ...otherOptions];
					const key = variantOptions.sort().join('::');
					const found = this.mainProductAvailabilityMap.get(key);
					if (found) {
						variantIdsWithQty.push(`${found.id}:${count}`);
					}
				});

				if (variantIdsWithQty.length > 0) {
					idInput.setAttribute('data-pack-children', variantIdsWithQty.join(','));
				} else {
					idInput.removeAttribute('data-pack-children');
				}

				this._updatePackSubtitles(packQuantity, packDiscountPercent, activeOptionWrapper);
				this.updateAddToCartButton({ isPack: true, hasUnavailable: !isCurrentSelectionAvailable });
			} else {
				this.showBIS = this.productForm.hasAttribute('data-show-bis');
				if (idInput) {
					idInput.removeAttribute('data-pack-children');
					idInput.removeAttribute('data-pack-discount');
				}

				this.optionSelectors.forEach((selector, selectorIndex) => {
					this.dataProduct.variants.forEach((variant) => {
						let matchCount = 0;
						variant.options.forEach((option, optionIndex) => {
							if (option === selectedOptions[optionIndex] && optionIndex !== selectorIndex) {
								matchCount += 1;
							}
						});
						if (matchCount === selectedOptions.length - 1) {
							const optionEl = Array.from(selector.querySelectorAll('.js-option')).find(opt => opt.value === variant.options[selectorIndex]);
							if (optionEl) {
								this._updateSingleOptionUI(optionEl, variant.available, !variant.available);
							}
						}
					});
				});
			}

            this.mainSection = this.closest('.shopify-section');

            if(this.mainSection && this.mainSection.querySelector('top-sticky-atc-panel')) {
              setTimeout(() => {
                this.mainSection.querySelector('top-sticky-atc-panel').renderVariants();
              }, 1);
            }
		}

		_updateSingleOptionUI(optionEl, available, soldout) {
			const el = optionEl;
			const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
			if (el.classList.contains('is-unavailable') === !available) return;
			el.classList.toggle('is-unavailable', !available);

			if (el.classList.contains('custom-select__option')) {
				let em = el.querySelector('em');
				if (!available) {
					if (!em) {
						el.insertAdjacentHTML('beforeend', `<em class="pointer-events-none">${text}</em>`);
					} else {
						em.textContent = text;
						em.hidden = false;
					}
				} else if (em) {
					em.hidden = true;
				}
			} else {
				if (!available) {
					el.nextElementSibling.title = text;
				} else {
					el.nextElementSibling.removeAttribute('title');
				}
			}
		}

		_isPackCombinationAvailable(options) {
			if (!this.mainProductAvailabilityMap) return false;

			const packBuildingOptions = options.slice(1);
			const colorOptionIndex = 0;
			const packDefinitionString = packBuildingOptions[colorOptionIndex];

			if (!packDefinitionString) return false;

			const rawColors = packDefinitionString.includes(' / ')
				? packDefinitionString.split(' / ').map(s => s.trim())
				: [packDefinitionString];

			const otherOptions = packBuildingOptions.filter((_, i) => i !== colorOptionIndex);

			return rawColors.every(entry => {
				const match = entry.match(/^(\d+)\s+(.*)$/);
				const count = match ? parseInt(match[1], 10) : 1;
				const color = match ? match[2] : entry;
				const variantOptions = [...otherOptions, color];

				const key = variantOptions.sort().join('::');
				const found = this.mainProductAvailabilityMap.get(key);

				if (!found || !found.available) return false;

				const stock = this.dataFormatted[found.id]?.inventory_quantity ?? 0;
				return !(found.inventory_management === 'shopify' && stock < count);
			});
		}

		_updatePackSubtitles(pack_quantity, discount_percent, activeOptionWrapper) {
			if (!this.mainProduct || !this.variant || !activeOptionWrapper) {
				return;
			}

			const subTitleEl = activeOptionWrapper.querySelector('.opt-label__sub-title');
			if (!subTitleEl || subTitleEl.dataset.metafieldPopulated === 'true') {
				return;
			}

			const selectedOptions = this.getSelectedOptions();
			const baseOptionsForPrice = selectedOptions.slice(1);
			const key = baseOptionsForPrice.sort().join('::');
			const mainVariant = this.mainProductAvailabilityMap.get(key);

			const singleItemPrice = mainVariant ? mainVariant.price : this.mainProduct.variants[0].price;

			if (pack_quantity > 0) {
				const finalPackPrice = (singleItemPrice * pack_quantity) * (1 - (discount_percent / 100));
				const pricePerItem = finalPackPrice / pack_quantity;
				const liquidPrice = parseInt(subTitleEl.dataset.pricePerItem, 10);
				const jsCalculatedPrice = Math.round(pricePerItem);
				if (!isNaN(liquidPrice) && jsCalculatedPrice !== liquidPrice) {
					const formattedPricePerItem = this.formatMoney(pricePerItem, this.moneyFormat);
					subTitleEl.textContent = `${formattedPricePerItem}/ITEM`;
				}
			}
		}

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.dataFormatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer') || this.section.matches('.kit-options')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    updateKitMedia() {
      if (!this.variant.featured_media) return;

      const container = this.section.closest('.kit-item').querySelector('.kit-item-slider-item.swiper-slide-active .product-single__photos');
      const dublicateContainer = this.section.closest('.kit-item').querySelectorAll('.kit-item-slider-item.swiper-slide-duplicate-active .product-single__photos');
      const image = this.variant.featured_media.preview_image;
      const special_image = this.dataFormatted[this.variant.id].special_image;

      function updateImage(container, self, special_image) {
        const width = container.offsetWidth;
        if (special_image) {
          container.innerHTML = `
          <img src="${special_image}&width=${width}" 
            srcset="${special_image}&width=${width}, ${special_image}&width=${width * 2} 2x" 
            width="${width * 2}" height="${(width * 2) / image.aspect_ratio}" alt="${self.variant.featured_media.alt}">
          `;
        } else {
          container.innerHTML = `
          <img src="${image.src}&width=${width}" 
            srcset="${image.src}&width=${width}, ${image.src}&width=${width * 2} 2x" 
            width="${width * 2}" height="${(width * 2) / image.aspect_ratio}" alt="${self.variant.featured_media.alt}">
          `;
        }
      }

      updateImage(container, this, special_image);
      if (dublicateContainer.length) {
        dublicateContainer.forEach(item => updateImage(item, this, special_image));
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      if(document.querySelector('.show-intelligems .intelligems-pdp') && window.matchMedia("(max-width: 768px)").matches){
        this.price = this.price || document.querySelector('.intelligems-pdp .product-info__price > .price');
      }else{
        this.price = this.price || this.section.querySelector('.product-info__price > .price');
      }

      if (!this.price) return;

			this.moneyFormat = this.moneyFormat || window.theme.settings.money_format || '${{amount}}';

			const idInput = this.productForm.querySelector('input[name="id"]');
			const packChildrenString = idInput?.dataset.packChildren;
			const priceCurrentEl = this.price.querySelector('.price__current');
			const priceWasEl = this.price.querySelector('.price__was');
			const unitPriceEl = this.price.querySelector('.unit-price');
			const stickyPriceEl = document.querySelector('.card--sticky-atc .price');
			const topStickyPriceEl = document.querySelector('.card--sticky-atc-top .price');

			let saleBadge = this.price.querySelector('.price__badge-sale');
			if (packChildrenString && this.variantPrices) {
				const discountPercent = idInput.dataset.packDiscount || 0;

				const requiredItems = packChildrenString.split(',').map(entry => {
					const [id, qty] = entry.split(':');
					return {id: parseInt(id, 10), qty: parseInt(qty, 10)};
				});

				let originalPrice = 0;
				requiredItems.forEach(item => {
					const price = this.variantPrices[item.id] || 0;
					originalPrice += price * item.qty;
				});

				const finalPrice = originalPrice * (1 - (discountPercent / 100));
				priceCurrentEl.innerHTML = this.formatMoney(finalPrice, this.moneyFormat);
				if (discountPercent > 0 && finalPrice < originalPrice) {
					priceWasEl.innerHTML = this.formatMoney(originalPrice, this.moneyFormat);
					this.price.classList.add('price--on-sale');
					priceCurrentEl.classList.add('has-compare');

					if (!saleBadge) {
						saleBadge = document.createElement('span');
						saleBadge.className = 'price__badge-sale';
						priceCurrentEl.after(saleBadge);
					}
					saleBadge.textContent = `SAVE ${discountPercent}%`;
					saleBadge.hidden = false;
				} else {
					priceWasEl.innerHTML = '';
					this.price.classList.remove('price--on-sale');
					priceCurrentEl.classList.remove('has-compare');

					if (saleBadge) saleBadge.hidden = true;
				}

				unitPriceEl.hidden = true;
				this.price.querySelector('.price__default').hidden = false;
				this.price.querySelector('.price__no-variant').hidden = true;
				this.price.classList.remove('price--sold-out');

				if (stickyPriceEl) {
					let stickySaleBadge = stickyPriceEl.querySelector('.price__badge-sale');
					const hasDiscount = discountPercent > 0 && finalPrice < originalPrice;

					if (hasDiscount) {
						if (!stickyPriceEl.querySelector('.price__default')) {
							stickyPriceEl.innerHTML = `
							 <div class="price__default">
								 <s class="price__was"></s>
								 <span class="price__current"></span>
							 </div>`;
						}

						const stickyCurrentEl = stickyPriceEl.querySelector('.price__current');
						const stickyWasEl = stickyPriceEl.querySelector('.price__was');

						if (stickyCurrentEl) stickyCurrentEl.innerHTML = this.formatMoney(finalPrice, this.moneyFormat);
						if (stickyWasEl) stickyWasEl.innerHTML = this.formatMoney(originalPrice, this.moneyFormat);
						stickyPriceEl.classList.add('price--on-sale');

						if (!stickySaleBadge) {
							stickySaleBadge = document.createElement('span');
							stickySaleBadge.className = 'price__badge-sale';
							stickyPriceEl.querySelector('.price__current').after(stickySaleBadge);
						}
						stickySaleBadge.textContent = `SAVE ${discountPercent}%`;
						stickySaleBadge.hidden = false;

					} else {
						const stickySpanEl = stickyPriceEl.querySelector('span');
						if (stickySpanEl) {
							stickySpanEl.innerHTML = this.formatMoney(finalPrice, this.moneyFormat);
						}
						stickyPriceEl.classList.remove('price--on-sale');
						if (stickySaleBadge) stickySaleBadge.hidden = true;
					}
				}
				if (topStickyPriceEl) {
					let topStickySaleBadge = topStickyPriceEl.querySelector('.price__badge-sale');
					const hasDiscount = discountPercent > 0 && finalPrice < originalPrice;

					if (hasDiscount) {
						if (!topStickyPriceEl.querySelector('.price__default')) {
                          topStickyPriceEl.innerHTML = `
							 <div class="price__default">
								 <span class="price__current"></span>
								 <s class="price__was"></s>
							 </div>`;
						}

						const topStickyCurrentEl = topStickyPriceEl.querySelector('.price__current');
						const topStickyWasEl = topStickyPriceEl.querySelector('.price__was');

						if (topStickyCurrentEl) topStickyCurrentEl.innerHTML = this.formatMoney(finalPrice, this.moneyFormat);
						if (topStickyWasEl) topStickyWasEl.innerHTML = this.formatMoney(originalPrice, this.moneyFormat);
                        topStickyPriceEl.classList.add('price--on-sale');

						if (!topStickySaleBadge) {
                            topStickySaleBadge = document.createElement('span');
                            topStickySaleBadge.className = 'price__badge-sale';
                            topStickyPriceEl.querySelector('.price__was').after(topStickySaleBadge);
						}
                        topStickySaleBadge.textContent = `SAVE ${discountPercent}%`;
                        topStickySaleBadge.hidden = false;

					} else {
						const topStickySpanEl = topStickyPriceEl.querySelector('span');
						if (topStickySpanEl) {
                          topStickySpanEl.innerHTML = this.formatMoney(finalPrice, this.moneyFormat);
						}
                        topStickyPriceEl.classList.remove('price--on-sale');
						if (topStickySaleBadge) topStickySaleBadge.hidden = true;
					}
				}
			} else {
				if (saleBadge) saleBadge.hidden = true;
				if (stickyPriceEl?.querySelector('.price__badge-sale')) {
					stickyPriceEl.querySelector('.price__badge-sale').hidden = true;
				}
				if (topStickyPriceEl?.querySelector('.price__badge-sale')) {
                    topStickyPriceEl.querySelector('.price__badge-sale').hidden = true;
				}

				if (this.variant) {

					// Update current price and original price if on sale.
					priceCurrentEl.innerHTML = this.dataFormatted[this.variant.id].price;
					if (priceWasEl) {
						priceWasEl.innerHTML = this.dataFormatted[this.variant.id].compareAtPrice || '';
						if (this.dataFormatted[this.variant.id].compareAtPrice) {
							priceCurrentEl.classList.add('has-compare');
						} else {
							priceCurrentEl.classList.remove('has-compare');
						}
					}

					// Update unit price, if specified.
					if (this.variant.unit_price_measurement) {
						const valueEl = this.price.querySelector('.unit-price__price');
						const unitEl = this.price.querySelector('.unit-price__unit');
						const value = this.variant.unit_price_measurement.reference_value;
						const unit = this.variant.unit_price_measurement.reference_unit;

						valueEl.innerHTML = this.dataFormatted[this.variant.id].unitPrice;
						unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
					}

					unitPriceEl.hidden = !this.variant.unit_price_measurement;
					this.price.classList.toggle(
						'price--on-sale',
						this.variant.compare_at_price > this.variant.price
					);
					this.price.classList.toggle('price--sold-out', !this.variant.available);

					if (stickyPriceEl) {
						const variantData = this.dataFormatted[this.variant.id];
						const hasComparePrice = !!variantData.compareAtPrice;
						if (hasComparePrice) {
							if (!stickyPriceEl.querySelector('.price__default')) {
								stickyPriceEl.innerHTML = `<div class="price__default"><s class="price__was"></s><span class="price__current"></span></div>`;
							}
							stickyPriceEl.querySelector('.price__current').innerHTML = variantData.price;
							stickyPriceEl.querySelector('.price__was').innerHTML = variantData.compareAtPrice;
							stickyPriceEl.classList.add('price--on-sale');
						} else {
							if (stickyPriceEl.querySelector('.price__default')) {
								stickyPriceEl.innerHTML = `<span></span>`;
							}
							stickyPriceEl.querySelector('span').innerHTML = variantData.price;
							stickyPriceEl.classList.remove('price--on-sale');
						}
					}
					if (topStickyPriceEl) {
						const variantData = this.dataFormatted[this.variant.id];
						const hasComparePrice = !!variantData.compareAtPrice;
						if (hasComparePrice) {
							if (!topStickyPriceEl.querySelector('.price__default')) {
                              topStickyPriceEl.innerHTML = `<div class="price__default"><span class="price__current"></span><s class="price__was"></s></div>`;
							}
                            topStickyPriceEl.querySelector('.price__current').innerHTML = variantData.price;
                            topStickyPriceEl.querySelector('.price__was').innerHTML = variantData.compareAtPrice;
                            topStickyPriceEl.classList.add('price--on-sale');
						} else {
							if (topStickyPriceEl.querySelector('.price__default')) {
                              topStickyPriceEl.innerHTML = `<span></span>`;
							}
                            topStickyPriceEl.querySelector('span').innerHTML = variantData.price;
                            topStickyPriceEl.classList.remove('price--on-sale');
						}
					}
				}

				this.price.querySelector('.price__default').hidden = !this.variant;
				this.price.querySelector('.price__no-variant').hidden = this.variant;
			}
    }

		formatMoney(cents, format) {
			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = (format || '${{amount}}');

			function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
				if (isNaN(number) || number == null) return 0;
				number = (number / 100.0).toFixed(precision);
				const parts = number.split('.');
				const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
				return dollars + (parts.length > 1 ? decimal + parts[1] : '');
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents);
					break;
				// ... можна додати інші кейси amount_no_decimals і т.д. за потреби ...
				default:
					value = formatWithDelimiters(cents);
			}
			return formatString.replace(placeholderRegex, value);
		}

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      // window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);

      const baseHandle = this.variant.product_handle ? this.variant.product_handle : this.dataset.url.split('/').pop();
      const newPathName = this.dataset.url.replace(/[^/]+$/, baseHandle);

      const newUrl = `${newPathName}?variant=${this.variant.id}`;
      window.history.replaceState({}, '', newUrl);

      this.dataset.url = newPathName;
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = !this.isKit ? this.section.querySelectorAll('.js-product-form-main, .js-instalments-form') : this.section.querySelectorAll('.kit-item--current .js-product-form-main');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
				input.dataset.preorder = this.variantPreorder ? true : false;
        input.dispatchEvent(new Event('change', { bubbles: true }));

        // const select = form.querySelector('select[name="id"]');
        // select.value = this.variant.id;
        // select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          let checkedInput = selector.querySelector('input:checked').value;
          let select = selector.querySelector('select.single-option-selector');
          if (select) {
            if (select.value != checkedInput) {
              select.value = checkedInput;
              var event = new Event('change');
              select.dispatchEvent(event);
            }

          }

          selectedOptions.push(checkedInput);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

		getSiblingProductData(e) {
			let el;

			if (e && e.target && e.target.matches('.js-option[data-product-handle]')) {
				const productHandle = e.target.dataset.productHandle;
				el = document.querySelector(`[type="application/json"][data-sibling-product="${productHandle}"]`);
				if (el && el.textContent) {
					try {
						const json = JSON.parse(el.textContent);
						this.currentSiblingProduct = json.product || null;
					} catch (err) {
						console.error('Failed to parse sibling JSON', err);
					}
				} else {
					this.currentSiblingProduct = this.getProductDataProduct();
				}
			}

			if (!this.currentSiblingProduct) {
				this.currentSiblingProduct = this.getProductDataProduct();
			}

			return this.currentSiblingProduct;
		}

		getMainProductData() {
			const handle = this.dataProduct?.handle || this.variant?.product_handle;
			let el;

			if (handle) {
				el = this.querySelector(`[type="application/json"][data-main-product-for="${handle}"]`);
			}

			if (!el) {
				el = this.querySelector('[type="application/json"][data-main-product]');
			}

			if (!el) {
				el = this.querySelector('[type="application/json"]:not([data-main-product-for])');
			}

			if (!el || !el.textContent) return null;

			try {
				const json = JSON.parse(el.textContent);
				return json.product || null;
			} catch (e) {
				console.error('Failed to parse main product JSON', e);
				return null;
			}
		}

    getProductDataProduct() {
      const dataElements = this.querySelectorAll('[type="application/json"]');
      if (dataElements.length === 0 || !dataElements[0].textContent) return null;

      const baseData = JSON.parse(dataElements[0].textContent);
      let dataProduct = baseData.product;
      if (baseData.product_fit_option) {
        dataProduct.product_fit_option = baseData.product_fit_option
        dataProduct.options.unshift('Fit');
      }
      dataProduct.product_handle = dataProduct.handle;
      if (!dataProduct) return null;

      this.processVariants(dataProduct, baseData.product_fit_option, dataProduct.handle, dataProduct.id);

      for (let i = 1; i < dataElements.length; i++) {
        let componentData = JSON.parse(dataElements[i].innerHTML);
        if (componentData && componentData.product) {
          this.processVariants(componentData.product, componentData.product_fit_option, componentData.product.handle, componentData.product.id, componentData.ignore_url_change);
          dataProduct.variants = dataProduct.variants.concat(componentData.product.variants);
        }
      }
      return dataProduct;
    }

    processVariants(product, fitOption, productHandle, productId, ignore_url_change = false) {
      if (!product.variants) return;

      product.variants.forEach(variant => {
        variant.product_handle = productHandle;
        variant.product_id = productId;
        variant.ignore_url_change = ignore_url_change;

        if (fitOption) {
          variant.options.unshift(fitOption);
          variant.option0 = fitOption;
        }

        if (ignore_url_change) {
          const sizeOptionPosition = fitOption ? 1 : 0;
          const originalOptionName = variant.option1;
          variant.option1 = `${product.title} ${originalOptionName}`;

          variant.options.forEach((option, index) => {
            if (index === sizeOptionPosition) {
              variant.options[index] = `${product.title} ${originalOptionName}`;
            }
          });
        }
      });
    }

    getProductDataFormatted() {
      const dataElements = this.querySelectorAll('[type="application/json"]');
      let dataFormatted = {};

      dataElements.forEach(element => {
        try {
          const parsedData = JSON.parse(element.textContent);

          if (parsedData && parsedData.formatted) {
            Object.entries(parsedData.formatted).forEach(([key, value]) => {
              dataFormatted[key] = value;
            });
          }
        } catch (error) {
          console.error(error);
        }
      });

      return dataFormatted;
    }

    updateSizingDropdown() {
      let sizingAnfFitBlock = this.section.querySelector('.disclosure__content[data-dropdown="sizing-and-fit"]');
      let url = `${this.dataset.url}?variant=${this.variant.id}&section_id=product-metafield-sizing-and-fit`;

      if (sizingAnfFitBlock != null) {
        fetch(url, {
          method: 'GET',
        }).then(response => {
          if (response.ok) {
            return response.text();
          }

        }).then(html => {
          this.section.querySelector('.disclosure__content[data-dropdown="sizing-and-fit"]').innerHTML = '';
          let tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          let productMetafield = tempDiv.querySelector('#product-metafield');

          this.section.querySelector('.disclosure__content[data-dropdown="sizing-and-fit"]').innerHTML = productMetafield.innerHTML;
        }).catch(error => {
          console.error('Error:', error);
        });
      }
    }

	_fetchProductData(handle) {
		return new Promise((resolve, reject) => {
			const productData = {};
			const promises = [];

			const selectors = {
				mainProduct: '.main-product',
				productLifestyle: '.product-lifestyle',
				pairsWell: '.product__pairs-well-with',
				reviewYotpoWidget: '.review-yotpo-widget-main',
				reviewWidget: '.review-widget',
				productRecommendations: 'product-recommendations',
			};

			const sectionMainProductID = this.getSectionId(selectors.mainProduct);
			const sectionLifestyleID = this.getSectionId(selectors.productLifestyle);
			const sectionPairsWellID = this.getSectionId(selectors.pairsWell);
			const sectionReviewsID = this.getSectionId(selectors.reviewYotpoWidget);
			const sectionReviewsWidgetID = this.getSectionId(selectors.reviewWidget);
			const recommendationsSection = document.querySelector(selectors.productRecommendations);

			const isSpecial = this.isKit || this.isFeaturedProduct;

			if (sectionMainProductID) {
				const url = isSpecial
					? `${window.Shopify.routes.root}products/${handle}`
					: `${window.Shopify.routes.root}products/${handle}?section_id=${sectionMainProductID}`;

				const mainProductRequest = fetch(url)
					.then(response => response.text())
					.then(html => {
						const doc = new DOMParser().parseFromString(html, "text/html");
						const mainProductElement = isSpecial ? doc.querySelector('.main-product') : doc;

						const productHeader = mainProductElement.querySelector('[data-product-title]');
						if (productHeader) productData.productHeader = productHeader.innerHTML;

						const productDescription = mainProductElement.querySelector('.product-short-description');
						if (productDescription) productData.productShortDescription = productDescription.innerHTML;

						const productFitDescription = mainProductElement.querySelector('.product-fit--description');
						if (productFitDescription) productData.productFitDescription = productFitDescription.innerHTML;

						if (!isSpecial) {
							const selectorsMap = [
								{ selector: '.collapsible-content', key: 'productAccordions' },
								{ selector: '.product-info__rating', key: 'productYotpoStars' },
								{ selector: '[data-sticky-product-title]', key: 'productStickyBarHeader' },
							];
							selectorsMap.forEach(({ selector, key }) => {
								const element = mainProductElement.querySelector(selector);
								if (element) productData[key] = element.innerHTML;
							});
						}
					});
				promises.push(mainProductRequest);
			}

			if (!isSpecial) {
				const sectionsToFetch = [
					{ id: sectionLifestyleID, selector: selectors.productLifestyle, key: 'section_lifestyle' },
					{ id: sectionPairsWellID, selector: selectors.pairsWell, key: 'section_pairs_well' },
					{ id: sectionReviewsID, selector: selectors.reviewYotpoWidget, key: 'section_yotpo_reviews' },
					{ id: sectionReviewsWidgetID, selector: selectors.reviewWidget, key: 'section_reviews_widget' },
				];

				sectionsToFetch.forEach(({ id, selector, key }) => {
					if (id) {
						const request = fetch(`${window.Shopify.routes.root}products/${handle}?section_id=${id}`)
							.then(response => response.text())
							.then(html => {
								const doc = new DOMParser().parseFromString(html, "text/html");
								const element = doc.querySelector(selector);
								if (element) productData[key] = element.innerHTML;
							});
						promises.push(request);
					}
				});

				if (recommendationsSection) {
					const productRecommendationsUrl = recommendationsSection.getAttribute('data-url');
					const newRecommendationsUrl = productRecommendationsUrl.replace(/product_id=\d+/, `product_id=${this.productId}`);
					const recommendationsRequest = fetch(newRecommendationsUrl)
						.then(response => response.text())
						.then(html => {
							const doc = new DOMParser().parseFromString(html, "text/html");
							const element = doc.querySelector(selectors.productRecommendations);
							if (element) productData.section_recommendations = element.innerHTML;
						});
					promises.push(recommendationsRequest);
				}
			}

			Promise.all(promises)
				.then(() => resolve(productData))
				.catch(error => reject(error));
		});
	}

	initSiblingProductPreloading() {
		const siblingSelectorContainer = this.querySelector('.option-selector-fit');
		if (!siblingSelectorContainer) {
			return;
		}
		const optionInputs = siblingSelectorContainer.querySelectorAll('input[data-product-handle]');

		optionInputs.forEach(input => {
			const handle = input.dataset.productHandle;
			if (handle && !this.sectionsContent[handle]) {
				this._fetchProductData(handle)
					.then(data => {
						this.sectionsContent[handle] = data;
					})
					.catch(error => {
						console.error(`Failed to preload data for handle: ${handle}`, error);
					});
			}
		});
	}

	getSectionId(selector) {
		const element = document.querySelector(selector);
		if (element && element.closest('.shopify-section')) {
			return element.closest('.shopify-section').getAttribute('id').replace('shopify-section-', '');
		}
		return null;
	}

	async updatePageContent() {
		const handle = this.variant.product_handle;

		if (this.sectionsContent[handle]) {
			if (this.isKit) {
				this.updateKitContent(handle);
			} else if (this.isFeaturedProduct) {
				this.updateFeaturedContent(handle);
			} else {
				this.updateDefaultContent(handle);
			}

			if (typeof yotpo !== 'undefined') {
				yotpo.refreshWidgets();
			}
			window.initLazyImages();
			return;
		}
		this.classList.add('is-unavailable');

		try {
			const data = await this._fetchProductData(handle);

			this.sectionsContent[handle] = data;

			if (this.isKit) {
				this.updateKitContent(handle);
			} else if (this.isFeaturedProduct) {
				this.updateFeaturedContent(handle);
			} else {
				this.updateDefaultContent(handle);
			}

			if (typeof yotpo !== 'undefined') {
				yotpo.refreshWidgets();
			}
			window.initLazyImages();
		} catch (error) {
			console.error('Error fetching on-demand content:', error);
		} finally {
			this.classList.remove('is-unavailable');
		}
	}

	updateHeaderContent(handle, value) {
		if (this.isKit) {
			this.setKitNewContent('.kit-item', '.kit-item-slider-item.swiper-slide-active .product-single__title', value);
			this.setKitNewContent('.kit-item', '.main-product.kit-item--current [data-product-title]', value);
		} else if (this.isFeaturedProduct) {
			this.setKitNewContent('.main-product', '.product-title', value);
		} else {
			this.setNewContent('.main-product [data-product-title]', value);
		}
	}

	updateProductLink(handle) {
		const linkValue = { attr: 'href', value: `/products/${handle}` };
		if (this.isKit) {
			this.setKitNewContent('.kit-item', '.main-product.kit-item--current .view-product-link', linkValue);
		} else if (this.isFeaturedProduct) {
			this.setKitNewContent('.main-product', '.view-product-link', linkValue);
		}
	}

	updateKitContent(handle) {
		this.updateHeaderContent(handle, this.sectionsContent[handle].productHeader);
		this.updateProductLink(handle);

		this.setKitNewContent('.kit-item', '.main-product.kit-item--current .product-short-description', this.sectionsContent[handle].productShortDescription);
		this.setKitNewContent('.kit-item', '.main-product.kit-item--current .product-fit--description', this.sectionsContent[handle].productFitDescription);
	}

	updateFeaturedContent(handle) {
		this.updateHeaderContent(handle, this.sectionsContent[handle].productHeader);
		this.updateProductLink(handle);

		this.setKitNewContent('.main-product', '.product-short-description', this.sectionsContent[handle].productShortDescription);
		this.setKitNewContent('.main-product', '.product-fit--description', this.sectionsContent[handle].productFitDescription);
	}

	updateDefaultContent(handle) {
        const activeVariant = this.variant;

        this.setNewAttribute('[data-sticky-product-image]', 'src', activeVariant.featured_image.src);
        this.setNewAttribute('[data-sticky-product-image]', 'srcset', activeVariant.featured_image.src);

		this.setNewContent('.main-product .product-short-description', this.sectionsContent[handle].productShortDescription);
		this.setNewContent('.main-product .product-fit--description', this.sectionsContent[handle].productFitDescription);
		this.setNewContent('.main-product .collapsible-content', this.sectionsContent[handle].productAccordions);
		this.setNewContent('.main-product .product-info__rating', this.sectionsContent[handle].productYotpoStars);
		this.setNewContent('[data-sticky-product-title]', this.sectionsContent[handle].productStickyBarHeader);
		this.setNewContent('.main-product [data-product-title]', this.sectionsContent[handle].productHeader);
		this.setNewContent('.product-lifestyle', this.sectionsContent[handle].section_lifestyle);
		this.setNewContent('.product__pairs-well-with', this.sectionsContent[handle].section_pairs_well);
		this.setNewContent('.review-yotpo-widget-main', this.sectionsContent[handle].section_yotpo_reviews);
		this.setNewContent('.review-widget', this.sectionsContent[handle].section_reviews_widget);
		this.setNewContent('product-recommendations', this.sectionsContent[handle].section_recommendations);
	}

	setNewContent(selector, value) {
		if (document.querySelector(selector)) {
			if (!value) {
				document.querySelector(selector).style.display = 'none';
			} else {
				document.querySelector(selector).style.display = 'block';
				document.querySelector(selector).innerHTML = value;
			}
		}
	}

    setNewAttribute(selector, attribute, value) {
      const element = document.querySelector(selector);
      if (element && value) {
        element.setAttribute(attribute, value);
      }
    }

    setKitNewContent(parent, selector, value) {
		const container = this.closest(parent);
		if (!container) return;

		const el = container.querySelector(selector);
		if (!el) return;

		if (typeof value === 'object' && value.attr && value.value !== undefined) {
			el.setAttribute(value.attr, value.value);
		} else {
			el.innerHTML = value;
		}
	}

	updateShippingDate() {
		this.shippingDate = this.shippingDate || this.section.querySelector('.shipping-date');
		if (!this.shippingDate) return;

		let hideShippingDate = true;

		if ((this.variant && !this.variant.available && this.dataFormatted[this.variant.id].shippingDate != undefined) || this.variantPreorder && this.dataFormatted[this.variant.id].shippingDate != undefined) {
			this.shippingDate.innerHTML = this.dataFormatted[this.variant.id].shippingDate;
			hideShippingDate = false;
		}

		this.shippingDate.hidden = hideShippingDate;
	}

	adjustColorLabelPosition() {
		const containerEl = this.querySelector('.option-selector-color');
		if (!containerEl) return;

		const checkedInput = containerEl.querySelector('input.js-option:checked');
		if (!checkedInput) return;

		const activeLabel = checkedInput.closest('.option-wrapper')?.querySelector('.js-value');
		if (!activeLabel) return;

		const parentLabelEl = activeLabel.closest('.opt-label');
		if (!parentLabelEl) return;

		const containerRect = containerEl.getBoundingClientRect();
		const parentLabelRect = parentLabelEl.getBoundingClientRect();

		activeLabel.style.left = '50%';
		activeLabel.style.right = 'auto';
		activeLabel.style.transform = 'translateX(-50%)';

		const updatedLabelRect = activeLabel.getBoundingClientRect();
		if (updatedLabelRect.left < containerRect.left) {
			const offset = containerRect.left - parentLabelRect.left;
			activeLabel.style.left = `${offset}px`;
			activeLabel.style.transform = 'none';
		}
		else if (updatedLabelRect.right > containerRect.right) {
			const requiredLeftPosition = containerRect.right - parentLabelRect.left - updatedLabelRect.width;
			activeLabel.style.left = `${requiredLeftPosition}px`;
			activeLabel.style.transform = 'none';
		}
	}

  }

  customElements.define('variant-picker', VariantPicker);
}
